import Plugins from "@/entities/Plugins";
import PluginDetail from "@/entities/PluginsDetails";
import pluginsData from "@/data/plugins.json";
import pluginDetailsData from "@/data/pluginDetails.json";

const plugins = pluginsData as unknown as Plugins[];
const pluginDetails = pluginDetailsData as unknown as PluginDetail[];

export default class PluginsService {
  public async getPlugins(): Promise<Plugins[]> {
    return plugins;
  }

  public async getFilteredPlugins(filter: boolean): Promise<Plugins[]> {
    return plugins.filter(
      (plugin) => Boolean(Number(plugin.soon)) === filter
    );
  }

  public async getDetallePluginById(id: number): Promise<PluginDetail[]> {
    return pluginDetails.filter((detalle) => detalle.plugin_id === id);
  }
}
